import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import Toaster from "../../../../Components/Toaster";
import Loader from "../../../../Components/Loader";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useContext, useState, useEffect, useRef } from "react";
import Select from "react-select";
import { GlobalInfo } from "../../../../Contexts/GlobalContext";
import TokenService from "../../../../Services/Token.service";
import * as Yup from "yup";
import { AdminService } from "../../../../Services/Admin.service";

// Validation Schema
const validationSchema = Yup.object().shape({
    title: Yup.string().required("Message Title is required"),
    subject: Yup.string().required("Subject is required"),
    from: Yup.string().required("From is required"),
    replyto: Yup.array().min(1, "At least one reply-to address is required").required("Reply to is required"),
    bcc: Yup.array().min(1, "At least one BCC address is required").required("BCC is required"),
    email: Yup.string().required("Email template is required"),
});


const SingleSelectField = ({ fieldName, label, options, setFieldValue, values }) => {
    return (
        <div className="col-md-4">
            <label htmlFor={fieldName} className="form-label">
                {label}
            </label>
            <select
                name={fieldName}
                className="form-control"
                value={values[fieldName] || ""}
                onChange={(e) => setFieldValue(fieldName, e.target.value)}
            >
                <option value="" disabled>
                    Select {label}
                </option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            <ErrorMessage name={fieldName} component="div" className="text-danger" />
        </div>
    );
};


const MultiSelectField = ({ fieldName, label, options, setFieldValue, values }) => {
    return (
        <div className="col-md-4">
            <label htmlFor={fieldName} className="form-label">
                {label}
            </label>
            <Select
                placeholder={`Please Select ${fieldName}`}
                isMulti
                name={fieldName}
                options={options}
                value={values[fieldName]?.map((val) => options.find((opt) => opt.value === val)) || []}
                onChange={(selected) => {
                    setFieldValue(fieldName, selected ? selected.map((item) => item.value) : []);
                }}
                className="basic-multi-select"
                classNamePrefix="select"
            />
            <ErrorMessage name={fieldName} component="div" className="text-danger" />
        </div>
    );
};
function AddEmailTemplate() {
    const { useType } = useParams();
    const location = useLocation();
    const { isSidebarVisible } = useContext(GlobalInfo);

    // Check if data is passed for editing
    const emailTemplateData = location.state?.emailTemplate;

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastVariant, setToastVariant] = useState("");
    const [loading, setLoading] = useState(false);
    const editorRef = useRef(null);
    const editorInstance = useRef(null);
    const previousUrl = TokenService.getPrevLink();
    const navigate = useNavigate();
    const [navigateToEmailTemplateList, setNavigateToEmailTemplateList] = useState(false);
    const [emailOptions, setEmailOptions] = useState([]);

    const formikRef = useRef(null);

    useEffect(() => {

        console.log("emailTemplateData", emailTemplateData);

    }, [emailTemplateData]);

    const fetchEmailOptions = async () => {
        try {
            console.log("Fetching email options...");
            const options = await AdminService.getEmailTempletOptions();
            
            if (options.success) {

                const formattedOptions = options.emails.map((email) => ({
                    label: `${email.name}`,
                    // (${email.email})
                    value: email.email,
                }));


                setEmailOptions(formattedOptions);
            }
        } catch (err) {
            console.error("Error fetching email options:", err);

        }
    }
    useEffect(() => {
        fetchEmailOptions();
    }, [])
    const initialValues = emailTemplateData
        ? {
            template_id: emailTemplateData.id || "",
            type_id: emailTemplateData.type_id || "",
            title: emailTemplateData.title || "",
            subject: emailTemplateData.subject || "",
            email: emailTemplateData.message || "", // Rich text editor content
            from: emailTemplateData.from || "",
            replyto: emailTemplateData.replyto ? JSON.parse(emailTemplateData.replyto) : [],
            bcc: emailTemplateData.bcc ? JSON.parse(emailTemplateData.bcc) : [],
        }
        : {
            title: "",
            subject: "",
            email: "",
            from: "",
            replyto: [],
            bcc: [],
            // "genknooz2007@gmail.com", "96.david.war@gmail.com","testcaptcha2019@gmail.com"
        };

    const decodeHTML = (html) => {
        const textArea = document.createElement("textarea");
        textArea.innerHTML = html;
        return textArea.value;
    };
    useEffect(() => {
        const loadScript = (src, callback) => {
            const baseUrl = process.env.REACT_APP_BASE_URL || ""; 
            
            const script = document.createElement("script");
            // script.src = src;
            script.src = `${baseUrl}${src}`;
            script.onload = callback;
            document.body.appendChild(script);
        };

        loadScript("/richtexteditor/rte.js", () => {
            loadScript("/richtexteditor/plugins/all_plugins.js", () => {
                if (window.RichTextEditor) {
                    editorInstance.current = new window.RichTextEditor(editorRef.current);
                    const decodedMessage = decodeHTML(initialValues.email);
                    editorInstance.current.setHTMLCode(decodedMessage );
// || "<p>This is the default content.</p>"

                    // Attach change listener to update Formik state
                    editorInstance.current.attachEvent("change", () => {
                        const editorContent = editorInstance.current.getHTMLCode();

                        if (formikRef.current) {
                            // Update the Formik field value
                            formikRef.current.setFieldValue("email", editorContent);

                            // Trigger validation
                            formikRef.current.setFieldTouched("email", true);
                        }
                    });

                }
            });
        });

        return () => {
            if (editorInstance.current && typeof editorInstance.current.destroy === "function") {
                editorInstance.current.destroy();
            }
        };
    }, [initialValues.email]);

    const getEditorContent = () => {
        return editorInstance.current?.getHTMLCode() || "";
    };

    const handleSubmit = async (values, { resetForm }) => {
        setLoading(true);
        const typeMap = { admin: 1, requestor: 2, donor: 3 };


        // Exclude 'email' property from the payload
        const { email, ...rest } = values;

        const emailTemplateData = {
            ...rest,
            message: getEditorContent(),
            type_id: typeMap[useType],
        };

        try {
            let response;
            if (emailTemplateData) { //edit
                emailTemplateData.template_id = emailTemplateData.template_id;
                response = await AdminService.updateEmailTempletList(emailTemplateData);
            }
            else { //add
                response = await AdminService.addEmailTempletList(emailTemplateData);
            }
            if (response.success) {
                // resetForm();
                // setToastMessage(response.message);
                // setToastVariant("success");
                setLoading(false);
                setNavigateToEmailTemplateList(true);
            } else {
                setToastMessage(response.error);
                setToastVariant("error");
                setLoading(false);
            }

        } catch (error) {
            setToastMessage("Failed to add/update email template.");
            setToastVariant("error");
            setLoading(false);
        } finally {
            setShowToast(true);
            setLoading(false);
        }
    };


    // UseEffect to handle navigation
    useEffect(() => {
        if (navigateToEmailTemplateList) {
            const timer = setTimeout(() => {
                // administrative-settings
                navigate('/admin/email-sms-management', {
                    state: {
                        toastMessage: 'Email Template updated successfully!',
                        toastVariant: 'success',
                    }
                },);
            },);
            return () => clearTimeout(timer);
        }
    }, [navigateToEmailTemplateList]);


    const dropdownOptions = [
        { value: "genknooz2007@gmail.com", label: "genknooz2007" },
        { value: "testcaptcha2019@gmail.com", label: "testcaptcha2019" },
        { value: "96.david.war@gmail.com", label: "96.david.war" },
    ];

    return (
        <>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? "collapsed-body" : ""}`}>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">
                        {emailTemplateData ? "Edit Email Template" : "Add Email Template"}{" "}
                        {useType.charAt(0).toUpperCase() + useType.slice(1)}
                    </h2>
                    <Link className="back-link" to={`${previousUrl}`}>
                        <i className="el-icon-back"></i> Email & SMS Management
                    </Link>

                    <div className="el-bg-table el-super-admin">
                        <Formik
                            innerRef={formikRef}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize={true}
                        >
                            {({ setFieldValue, values }) => (
                                <Form>
                                    <div className="row col-xl-10">
                                        {["title", "subject"].map((field) => (
                                            <div className="col-md-4 " key={field}>
                                                <label htmlFor={field} className="form-label">
                                                    {field.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (c) => c.toUpperCase())}
                                                </label>
                                                <Field type="text" name={field} placeholder={`Enter ${field.slice(0, 1).toLocaleUpperCase()}${field.slice(1)}`} className="form-control" />
                                                <ErrorMessage name={field} component="div" className="text-danger" />
                                            </div>
                                        ))}

                                        <SingleSelectField
                                            fieldName="from"
                                            label="From"
                                            options={emailOptions}
                                            setFieldValue={setFieldValue}
                                            values={values}
                                        />

                                        {/* "from" */}
                                        {["replyto", "bcc"].map((field) => (
                                            <MultiSelectField
                                                key={field}
                                                fieldName={field}
                                                label={field.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (c) => c.toUpperCase())}
                                                options={emailOptions}
                                                setFieldValue={setFieldValue}
                                                values={values}
                                            />
                                        ))}

                                        <div className="col-md-12 ">
                                            <label htmlFor="email" className="form-label">
                                                Email
                                            </label>
                                            <div id="div_editor1" ref={editorRef}></div>
                                            <ErrorMessage name={"email"} component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className="d-flex mt-4">
                                        <button type="submit" className="btn el-filled-btn">
                                            <span>Save Changes</span>
                                        </button>
                                        <Link className="back-link btn el-filled-btn" to={`${previousUrl}`}>
                                            <span>Close</span>
                                        </Link>

                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
                </div>
            </div>
        </>
    );
}

export default AddEmailTemplate;
